/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */

export const filterObj = (obj, id = 0) => {
  if (!obj) return [];
  const value = Object.entries(obj).filter(item => item[0] === id);
  return value[0][1];
};
